import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";
import WalkInFormLabel from "./WalkInFormLabel";
import WalkInHelperText from "./WalkInHelperText";

function WalkInSelect({
  labelName,
  fieldName,
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
  options,
}) {
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 350,
      },
    },
  };
  return (
    <FormControl fullWidth>
      <WalkInFormLabel labelName={labelName} />
      <Select
        name={fieldName}
        fullWidth
        onChange={handleChange}
        onBlur={handleBlur}
        value={values}
        MenuProps={MenuProps}
        displayEmpty
      >
        <MenuItem value="" disabled>
          Please Select
        </MenuItem>
        {options.map((val, ind) => (
          <MenuItem key={val.title} value={val.title}>
            {val.title}
          </MenuItem>
        ))}
      </Select>
      <WalkInHelperText helperText={errors} errors={touched && errors} />
    </FormControl>
  );
}

export default WalkInSelect;
